module.exports = __webpack_public_path__ + "static/Icons_LTV_Inactive-41ebd0de6c5d2338aa1068f4f687c041.png";